module.exports = require("@swa-ui/vacations/src/VacationsBookingForm/PackageOptions/PackageOptions.module.scss");